import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
const PrivacyData = () => {
    const navigator = useNavigate();
    return (
        <>
            <Helmet>
                <title>Privacy | TLK</title>
            </Helmet>
            {/* start: privacy page */}
            <div className="min-h-screen gradient-bg-1">
                <div className="fixed w-full top-0 bg-background/95 backdrop-blur-sm border-b border-border px-4 py-3 flex items-center gap-3 z-10">
                    <button className="text-foreground"
                        onClick={() => navigator(-1)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-arrow-left w-6 h-6"
                        >
                            <path d="m12 19-7-7 7-7" />
                            <path d="M19 12H5" />
                        </svg>
                    </button>
                    <h1 className="text-lg font-semibold text-foreground">Privacy & Data</h1>
                </div>
                <div
                    className="p-6 pt-[100px] max-w-2xl mx-auto"
                    style={{ opacity: 1, transform: "none" }}
                >
                    <main className="max-w-5xl mx-auto px-6 pb-16">
                        {/* Introduction */}
                        <section className="bg-card rounded-2xl p-6 border border-border shadow-md mb-6">
                            <h2 className="text-xl font-semibold mb-3">1. Introduction</h2>
                            <p className="text-gray-600 leading-relaxed">
                                We value your privacy and are committed to protecting your personal data.
                                This Privacy Policy explains how we collect, use, and safeguard your
                                information when you use our website and services.
                            </p>
                        </section>
                        {/* Information We Collect */}
                        <section className="bg-card rounded-2xl p-6 border border-border shadow-md mb-6">
                            <h2 className="text-xl font-semibold mb-4">2. Information We Collect</h2>
                            <ul className="list-disc list-inside space-y-2 text-gray-600">
                                <li>Personal information (name, email address, phone number)</li>
                                <li>Account and profile data</li>
                                <li>Usage data (pages visited, session duration)</li>
                                <li>Cookies and tracking technologies</li>
                            </ul>
                        </section>
                        {/* How We Use Information */}
                        <section className="bg-card rounded-2xl p-6 border border-border shadow-md mb-6">
                            <h2 className="text-xl font-semibold mb-4">
                                3. How We Use Your Information
                            </h2>
                            <ul className="list-disc list-inside space-y-2 text-gray-600">
                                <li>Provide and maintain our services</li>
                                <li>Improve website performance and experience</li>
                                <li>Send important updates or notifications</li>
                                <li>Ensure security and prevent fraud</li>
                            </ul>
                        </section>
                        {/* Data Protection */}
                        <section className="bg-card rounded-2xl p-6 border border-border shadow-md mb-6">
                            <h2 className="text-xl font-semibold mb-3">4. Data Protection</h2>
                            <p className="text-gray-600 leading-relaxed">
                                We implement appropriate technical and organizational measures to protect
                                your personal data from unauthorized access, alteration, disclosure, or
                                destruction.
                            </p>
                        </section>
                        {/* Third Party Services */}
                        <section className="bg-card rounded-2xl p-6 border border-border shadow-md mb-6">
                            <h2 className="text-xl font-semibold mb-3">5. Third-Party Services</h2>
                            <p className="text-gray-600 leading-relaxed">
                                We may share your data with trusted third-party providers to operate our
                                services. These providers are contractually obligated to keep your data
                                secure.
                            </p>
                        </section>
                        {/* Your Rights */}
                        <section className="bg-card rounded-2xl p-6 border border-border shadow-md mb-6">
                            <h2 className="text-xl font-semibold mb-3">6. Your Rights</h2>
                            <p className="text-gray-600 leading-relaxed">
                                You have the right to access, update, or request deletion of your personal
                                information. Contact us to exercise your rights.
                            </p>
                        </section>
                        {/* Contact */}
                        <section className="bg-card rounded-2xl p-6 border border-border shadow-md mb-6">
                            <h2 className="text-xl font-semibold mb-3">7. Contact Us</h2>
                            <p className="text-gray-600">
                                If you have questions regarding this Privacy Policy, please contact:
                            </p>
                            <p className="mt-2 font-medium text-gray-800">support@syntimacy.co</p>
                        </section>
                    </main>

                </div>
            </div>

            {/* end: privacy page */}
        </>
    );
}

export default PrivacyData;
